// Extract a human-readable message from a PocketBase SDK error.
// PB errors carry a response body like:
//   { message: "Failed to create record.", data: { title: { code, message } } }
// The SDK's err.message is generic ("Failed to create record.") — the
// field-level detail (why it failed) is what users need to act on.
export function pbErrorMessage(err, fallback = 'Something went wrong') {
  const data = err?.response?.data || err?.data;
  if (data?.message) {
    const fields = data.data
      ? Object.entries(data.data).map(([key, value]) => `${key}: ${value?.message || JSON.stringify(value)}`)
      : [];
    return fields.length ? `${data.message} — ${fields.join('; ')}` : data.message;
  }
  return err?.message || fallback;
}
